import { render, staticRenderFns } from "./AthleteAccessControlForm.vue?vue&type=template&id=3a767dcc&scoped=true&"
import script from "./AthleteAccessControlForm.vue?vue&type=script&lang=ts&"
export * from "./AthleteAccessControlForm.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteAccessControlForm.vue?vue&type=style&index=0&id=3a767dcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a767dcc",
  null
  
)

export default component.exports